import React, { forwardRef, useImperativeHandle,  useEffect } from "react";
import PropTypes from "prop-types";
import Badge from "../../atoms/badge/badge";
import { IconType } from "../icon/icon";

const InputTag = forwardRef((props, ref) => {
  const { placeholder, value, onChange, id } = props;

  const [tags, setTags] = React.useState([]);

  useEffect(() => {
    if (value !== null && value.length > 0) {
      if (typeof value === "string") {
        const normalized = [...new Set(value.split(',').map(v => v.trim()).filter(Boolean))];
        setTags(normalized);
      } else {
        setTags(value.split(','))
      }
    }
  }, [value]);

  const addTags = (event) => {
    if (event.key === "Enter" && event.target.value !== "") {
      const raw = event.target.value;
      const parts = raw.split(",").map((s) => s.trim()).filter(Boolean);
      if (parts.length === 0) return;
      const next = [...tags, ...parts];
      setTags(next);

      onChange({ ...event, target: { value: next.join(",") } });
      event.target.value = "";
    }
  };

  const onClickBadge = (event, valueStateIndex) => {
    const newState = [...tags];
    newState.splice(valueStateIndex, 1);
    setTags(newState);
    onChange({ ...event, target: { value: newState.join() } });
  };

  useImperativeHandle(ref, () => ({
    updateValue(tags) {
      // setTags(tags === null ? '' : tags);
    },
  }));

  return (
    <div className="tags-input">
      {tags.map((tag, index) => (
        <Badge
          key={index}
          icon={IconType.CLOSE}
          onClick={(event) => onClickBadge(event, index)}
        >
          {tag}
        </Badge>
      ))}
      <input
        type="text"
        id={id}
        ref={ref}
        onKeyUp={(event) => addTags(event)}
        placeholder={placeholder}
        className={`form-control  `}
      />
    </div>
  );
});

InputTag.propTypes = {
  /**
   * Placeholder inside the HTML input
   */
  placeholder: PropTypes.string,
  /**
   * Set the value inside the HTML input
   */
  value: PropTypes.node,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
};

InputTag.defaultProps = {
  placeholder: "",
  value: "",
  onChange: () => {},
};

export default InputTag;
